import script from "./JugadoresEjercitos.vue?vue&type=script&setup=true&lang=ts"
export * from "./JugadoresEjercitos.vue?vue&type=script&setup=true&lang=ts"

import "./JugadoresEjercitos.vue?vue&type=style&index=0&id=2f0f9bff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0f9bff"]])

export default __exports__